import { render, staticRenderFns } from "./noScore.vue?vue&type=template&id=62d295e6&scoped=true&"
import script from "./noScore.vue?vue&type=script&lang=js&"
export * from "./noScore.vue?vue&type=script&lang=js&"
import style0 from "./noScore.vue?vue&type=style&index=0&id=62d295e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d295e6",
  null
  
)

export default component.exports